/**
 * @file: 优惠券领取
 * @author: wence
 */
import React, {PureComponent, Fragment} from 'react';
import PropType from 'prop-types';
import {Modal, Toast} from 'antd-mobile';
import cn from 'classnames';
import {connect} from 'react-redux';
import './index.less';
import {getConpinInfo, receiveConpin} from '../../actions/conpinAction';

import {fetchInstanceGetInstance} from '../../actions/buyAction';
const voucherTypes = {
    1: '现金券',
    2: '折扣券',
    3: '兑换券'
};

class ConpinModal extends PureComponent {
    static propTypes = {
        instance: PropType.object,
        loginInfo: PropType.object,
        fetchInstanceGetInstance: PropType.func
    }
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            conpinInfo: null,
            successReceive: false,
            isDisabled: false
        };
    }
    componentDidMount() {
        const params = this.getParams();

        if (params['voucher_id'] && params['voucher_flag']) {
            this.getConpinInfo({
                'voucher_id': params['voucher_id'],
                'voucher_flag': params['voucher_flag'],
                channel: params['channel'] || '2'
            });
        }
    }

    getConpinInfo = async params => {
        await this.props.fetchInstanceGetInstance();

        const instance = this.props.instance;

        if (instance.status === 0 && instance.data) {
            params['instance_id'] = Object.keys(instance.data)[0] || '';
        }

        const res = await getConpinInfo(params);

        if (res && res.status === 0) {
            if (res.data) {
                this.setState({
                    visible: true,
                    conpinInfo: res.data,
                    isDisabled: res.data['is_buy'] === 1 || res.data['is_buy'] === 2
                });
            }
        }
    }

    receiveConpin = async () => {
        if (this.state.isDisabled) {
            return;
        }

        const loginInfo = this.props.loginInfo;
        if (!(loginInfo && loginInfo.status === 0)) {
            window.location.href = this.loginUrl();
            return;
        }

        const instance = this.props.instance;
        if (instance.status === 0 && instance.data) {
            let data = {};

            try {
                data = JSON.parse(window.localStorage.getItem('__abbaidu_20181211_cb')) || {};
            }
            catch (e) {
                data = {};
            }

            const res = await receiveConpin({
                'instance_id': Object.keys(instance.data)[0],
                'voucher_id': this.state.conpinInfo['voucher_id'],
                'voucher_flag': this.state.conpinInfo['voucher_flag'],
                // 'voucher_service': this.state.conpinInfo['voucher_service'],
                // 'voucher_meal': this.state.conpinInfo['voucher_meal'],
                // 'voucher_type': this.state.conpinInfo['voucher_type'],
                // 'voucher_name': this.state.conpinInfo['voucher_name'],
                // 'voucher_price': this.state.conpinInfo['voucher_price'],
                'data': data && data.data,
                'key_id': data && data['key_id'],
                'sign': data && data.sign
            });

            if (res && res.status === 0 && res.data && res.data.status === 'success') {
                this.setState({successReceive: true});
            }
            else if (res && res.status === 0 && res.data && res.data.status === 'fail') {
                Toast.info('领取失败');
            }
            else if (res && res.status === 401) {
                window.location.href = this.loginUrl();
            }
            else {
                Toast.info(res && res.description || '领取失败');
            }
        }
    }

    renderReciveBody = () => {
        const loginInfo = this.props.loginInfo;
        const conpinInfo = this.state.conpinInfo || {};
        return (
            <Fragment>
                <div className="conpin-value">
                    <div className="conpin-value-main">
                        {conpinInfo['voucher_type'] === 1 && <span className="unit">￥</span>}
                        {conpinInfo['voucher_type'] === 1
                            && <span className="price">
                                {conpinInfo['voucher_price']}
                            </span>}
                        {conpinInfo['voucher_type'] === 3 && <span className="price">
                            {conpinInfo['try_time'] ? conpinInfo['try_time'] : '0天'}
                        </span>}
                    </div>
                    <div className="conpin-value-des">
                        {voucherTypes[conpinInfo['voucher_type']] || ''}
                    </div>
                </div>
                <div className="conpin-name">
                    {conpinInfo['voucher_scope']}
                </div>
                {!this.state.successReceive
                    && <div
                        onClick={this.receiveConpin}
                        className={cn('conpin-btn', {disabled: this.state.isDisabled})}>
                        {['点击领取', '已领取', '已抢完'][conpinInfo && conpinInfo['is_buy']] || '点击领取'}
                    </div>}
                {!this.state.successReceive && !(loginInfo && loginInfo.status === 0)
                    && <div className="no-login">登录即可领取优惠券</div>}
                {this.state.successReceive
                    && <div className="receive-success">领取成功</div>}
            </Fragment>
        );
    }

    render() {
        return (
            <Modal
                animationType="slide"
                maskTransitionName="mask-transition"
                className="conpin"
                visible={this.state.visible}
                transparent>
                <div className="conpin-container">
                    <div className="conpin-body">
                        <div className={cn('conpin-body-bg', {success: this.state.successReceive})}>
                            {this.renderReciveBody()}
                        </div>
                    </div>
                </div>
                <div
                    className="conpin-close"
                    onClick={() => this.setState({visible: false})}></div>
            </Modal>
        );
    }
}

export default connect(
    state => ({
        instance: state.instanceGetinstance,
        loginInfo: state.userLoginstate
    }),
    dispatch => ({fetchInstanceGetInstance: () => fetchInstanceGetInstance(dispatch)})
)(ConpinModal);



// WEBPACK FOOTER //
// ./src/components/conpin/index.js